import axios from 'axios';

import { SOLICITUDES_WA } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarSolicitudesWA = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/solicitudes_wa/listar`, body, config);

        await dispatch({
            type: SOLICITUDES_WA.BUSCAR,
            payload: res.data.solicitudes
        });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const detallesSolicitudWA = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/solicitudes_wa/detalles`, body, config);

        await dispatch({
            type: SOLICITUDES_WA.DETALLES,
            payload: res.data.solicitud
        });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarSolicitudWA = () => dispatch => {
    dispatch({
        type: SOLICITUDES_WA.DETALLES,
        payload: null
    });
}

export const asignarSolicitudWA = ({ id, usuario }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ id, usuario: usuario._id || usuario });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/solicitudes_wa/asignar`, body, config);

        await dispatch({
            type: SOLICITUDES_WA.ASIGNAR,
            payload: { id, usuario }
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const cambiarStatusSolicitudWA = ({ id, status }) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ id, status });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/solicitudes_wa/status`, body, config);

        await dispatch({
            type: SOLICITUDES_WA.STATUS,
            payload: { id, status }
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const convertirSolicitudWA = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/solicitudes_wa/convertir`, body, config);

        await dispatch({
            type: SOLICITUDES_WA.CONVERTIR,
            payload: { id, asesoria: res.data.asesoria }
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const eliminarSolicitudWA = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/solicitudes_wa/eliminar`, body, config);

        await dispatch({
            type: SOLICITUDES_WA.ELIMINAR,
            payload: id
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}
